<template>
  <div class="content flex-box">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity/get-list"
      entity-name="活动"
      query="&sort=-start_time"
      hide-edit
      :action="action"
      :columns="columns"
      :search-key-type="{name: 1}"
      :custom-url="customUrl"
      :custom-delete="customDelete"
      @detail="showDetail">
      <template v-slot:button>
        <a-button type="primary" @click="addActivity" v-action:add>创建活动</a-button>
      </template>
      <template v-slot:query="{form}">
        <a-form-model-item label="活动时间">
          <a-range-picker
            v-model="form.time"
            :placeholder="['开始时间', '结束时间']"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            @change="updateList"/>
        </a-form-model-item>
        <a-form-model-item label="活动状态">
          <a-select v-model="form.status" :options="statusList" placeholder="选择活动状态筛选" @change="updateList" style="width: 180px"></a-select>
        </a-form-model-item>
        <a-form-model-item label="是否在论坛显示">
          <a-select
            v-model="form.is_forum"
            allow-clear
            :options="[{key: 1, title: '是'},{key: 0, title: '否'}]"
            placeholder="选择是否在论坛显示筛选"
            @change="updateList" style="width: 180px"></a-select>
        </a-form-model-item>
        <a-form-model-item label="">
          <a-input v-model="form.name" placeholder="输入活动名称查询" @keyup.enter="updateList"></a-input>
        </a-form-model-item>
      </template>
    </data-list>
    <a-modal
      title="创建活动"
      centered
      ok-text="创建"
      :maskClosable="false"
      :closable="false"
      :width="800"
      @ok="confirmModal"
      v-model="visible">
      <form-area
        ref="modalForm"
        class="flex-box vertical"
        layout="horizontal"
        hide-btn
        :label-col="{span: 5}"
        :wrapper-col="{span: 19}"
        :items="items"
        :entity="form"
        confirm-text="提交"></form-area>
    </a-modal>
  </div>
</template>

<script>
    import {
        activityFormItems,
        getActivityStatus,
        getActivityShowTime, activityStatusList
    } from "../../common/activity/activity";
    import {getUserId} from "../../common/js/storage";
    import {isEmpty} from "../../common/js/tool";
    export default {
        name: "ActivityList",
        data() {
            return {
                columns: [
                    {title: '活动名称', dataIndex: 'name'},
                    {title: '活动时间', dataIndex: 'start_time', customRender: (text, record) => getActivityShowTime(record)},
                    {title: '状态', dataIndex: 'status', customRender: (text, record) => getActivityStatus(record)},
                    {title: '统筹人', dataIndex: 'chargeUser', customRender: (text) => text ? `${text.name}(${text.tel})` : '未设置'},
                    {title: '在论坛显示', dataIndex: 'is_forum', customRender: (text, record) => <a-switch checked={text == 1} loading={record.loading} onChange={(val) => this.isForumChange(val, record)} />},
                ],
                statusList: [{ key: 0, title: "所有活动"}, ...activityStatusList],
                visible: false,
                loading: false,
                form: {},
                items: activityFormItems
            }
        },
        computed: {
            action() {
                return this.$route.meta.action;
            },
        },
        methods: {
            isForumChange(checked, record) {
                const url = `/activity/activity/${record.id}`;
                this.$set(record, "loading", true);
                this.$axios.patch(url, { is_forum: checked ? 1 : 0}).then(res => {
                    this.$set(record, "is_forum", res.is_forum);
                }).finally(() => this.$set(record, "loading", false));
            },
            customUrl(form) {
                let res = "";
                if(form.time && form.time.length == 2) {
                    res += `&begin_time=${form.time[0]}&end_time=${form.time[1]}`;
                }
                if(form.status > 0) {
                    res += `&status=${form.status}`;
                }
                if(form.name) {
                    res += `&activity_name=${form.name}`;
                }
                if(!isEmpty(form.is_forum)) {
                    res += `&is_forum=${form.is_forum}`;
                }
                return res;
            },
            customDelete(item, index, fn) {
                this.$confirm({
                    title: '提示',
                    content: `确定删除此活动吗？`,
                    onOk: () => {
                        this.$axios({
                            url: `/activity/activity/${item.id}`,
                            method: 'DELETE'
                        }).then(() => {
                            this.$message.success('删除成功');
                            typeof fn === "function" && fn();
                        })
                    }
                });
            },
            showDetail({item}) {
                if(item.status == 4) {
                    this.$store.commit("setActivity", item);
                    this.$router.push({name: 'CreateActivity', params: {id: item.id}});
                } else {
                    this.$router.push({name: 'ActivityInfo', params: {id: item.id}});
                }
            },
            addActivity() {
                this.$router.push({name: 'CreateActivity', params: {id: 'new'}});
            },
            confirmModal() {
                if(this.loading) return;
                this.$refs.modalForm.handleConfirm().then(form => {
                    this.loading = true;
                    form.start_time = form.time[0];
                    form.end_time = form.time[1];
                    form.create_user_id = getUserId();
                    let url = `/activity/activity`, method = 'POST';
                    this.$axios({
                        url,
                        method,
                        data: form
                    }).then(() => {
                        this.visible = false;
                        this.updateList();
                    }).finally(() => {
                        this.loading = false;
                    });
                });
            },
            updateList() {
                this.$refs.dataList.getList();
            },
        }
    }
</script>

<style scoped>

</style>
